import type { StepLiquidityPool } from "@stepfinance/liquidity";
import { getLiquidityPoolName } from "@stepfinance/liquidity";

import type { CurrencyContextState } from "../contexts/swap";
import { PRICE_IMPACT_THRESHOLD } from "../utils/pools/utils";
import { getTokenName } from "../utils/tokenInfo";

export const CREATE_POOL_LABEL = "Create Liquidity Pool";
export const INSUFFICIENT_FUNDS_LABEL = (tokenName: string) => `Insufficient ${tokenName} funds`;
export const POOL_NOT_AVAILABLE = (tokenA: string, tokenB: string) => `Pool ${tokenA}/${tokenB} doesn't exist`;
export const ROUTE_NOT_AVAILABLE = (tokenA: string, tokenB: string) => `No route found for ${tokenA} → ${tokenB}`;

export const ADD_LIQUIDITY_LABEL = "Add Liquidity";
export const SWAP_LABEL = "Swap";
export const CONNECT_LABEL = "Connect Wallet";
export const CONNECT_YOUR_OWN_LABEL = "Connect your wallet to swap";
export const SELECT_TOKEN_LABEL = "Select a token";
export const ENTER_AMOUNT_LABEL = "Enter an Amount";
export const REMOVE_LIQUIDITY_LABEL = "Remove Liquidity";
export const PRICE_IMPACT_LABEL = "Price impact too high";
export const APPROVE_LABEL = "Approve transactions from your wallet";
export const AWAIT_LABEL = "Waiting for transaction to confirm";

export const generateActionLabel = (
  action: string,
  connected: boolean,
  A: CurrencyContextState,
  B: CurrencyContextState,
  ignoreToBalance = false,
  priceImpact: number,
  watching: boolean,
) => {
  if (!Number.isNaN(priceImpact) && priceImpact > PRICE_IMPACT_THRESHOLD) {
    return PRICE_IMPACT_LABEL;
  }

  if (!connected) {
    return CONNECT_LABEL;
  } else if (watching) {
    return CONNECT_YOUR_OWN_LABEL;
  } else if (!A.mintAddress || !B.mintAddress) {
    return SELECT_TOKEN_LABEL;
  } else if (!A.amount || !B.amount) {
    return ENTER_AMOUNT_LABEL;
  } else if (!A.sufficientBalance) {
    return INSUFFICIENT_FUNDS_LABEL(getTokenName(A.mintAddress));
  } else if (!ignoreToBalance && !B.sufficientBalance()) {
    return INSUFFICIENT_FUNDS_LABEL(getTokenName(B.mintAddress));
  } else {
    return action;
  }
};

export const generateRemoveLabel = (
  pendingTx: boolean,
  pendingConfirmation: boolean,
  connected: boolean,
  amount: number,
  pool: StepLiquidityPool,
  hasSufficientBalance: boolean,
) => {
  if (!connected) {
    return CONNECT_LABEL;
  } else if (!amount) {
    return ENTER_AMOUNT_LABEL;
  } else if (!hasSufficientBalance) {
    return INSUFFICIENT_FUNDS_LABEL(getLiquidityPoolName(pool));
  } else if (pendingConfirmation) {
    return AWAIT_LABEL;
  } else if (pendingTx) {
    return APPROVE_LABEL;
  }
  return REMOVE_LIQUIDITY_LABEL;
};
